import { ITouchModel } from '../auth/formTouchModelHooks';
import { IError } from './checker';

export const getErrorById = (list: IError[], id: string): IError => {
  if (!!list && !(list instanceof Array)) {
    return { resourceKey: '', id: '' };
  }
  return list.find((e) => e.id === id) || { resourceKey: '', id: '' };
};

export const isValidFieldById = (list: IError[], id: string): boolean => {
  if (!!list && !(list instanceof Array)) {
    return false;
  }
  return !list.find((e) => e.id === id);
};

export const isValid = (list: IError[]): boolean => {
  if (!!list && !(list instanceof Array)) {
    return false;
  }
  return list.length === 0;
};
export const isTouched = <Model extends Record<string | number, unknown>>(
  model: ITouchModel<Model>
): boolean => {
  const arrayOfValues = Object.keys(model).map((k) => model[k]);
  const hasAlmostOneTrue = arrayOfValues.some((e) => e);
  return hasAlmostOneTrue;
};

export const updateField = <
  T extends Record<string | number, unknown>,
  K extends keyof T,
  V extends T[K]
>(
  initialObject: T,
  field: K,
  value: V
): T => {
  return { ...initialObject, [field]: value };
};
